import styled from 'styled-components';
import {
  CenteredSpaceWrap,
  ButtonBase,
} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const OuterWrapDiv = styled.section(
  props => `
  display:flex;
  width:100%;
  position:sticky;
  top:-.01rem;
  z-index: ${props.theme.misc.zIndex.xlarge};
  background-color: ${props.theme.colors.goBrandBlue.base};
`,
);

export const WrapperStyle = styled(CenteredSpaceWrap)(
  props => `
  max-width: 120rem;
  width:100%;
  margin: 0 auto;
  padding: ${props.theme.spacing.custom(12)} 0;
  background-color: ${props.theme.colors.goBrandBlue.base};
`,
);

export const SearchWrapperArea = styled.div(
  props => `
  width: 33.7rem;
  padding-right: ${props.theme.spacing.custom(12)};
  position: relative;
`,
);

export const CheckinCheckoutWrapper = styled.div(
  props => `
  padding-right: ${props.theme.spacing.custom(12)};
`,
);

export const PaxWrapperStyle = styled.div(
  props => `
  padding-right: ${props.theme.spacing.small};
  position: relative;
`,
);

export const SearchLabelStyle = styled.label(
  props => `
  color: white;
  padding-bottom: ${props.theme.spacing.small};
  padding-left: ${props.theme.spacing.custom(2)};
  display:flex;
`,
);

export const SearchInputStyle = styled.input(
  props => `
  background-color: ${props.theme.colors.goBrandBlue.dark};
  color: white;
  border: none;
  font-size: ${props.theme.font.custom(16)};
  font-family: ${props.theme.font.fontFamily};
  font-weight: bold;

  display: block;
  width: 100%;
  height: 4.2rem;
  padding: ${props.theme.spacing.base} ${props.theme.spacing.base} ${props.theme.spacing.custom(
    12,
  )} ${props.theme.spacing.base};
    line-height: 1.3;
    border-radius: ${props.theme.misc.borderRadius.xlarge};
    flex-direction: row;
    align-items: center;
    justify-conent: center;
    &::-webkit-input-placeholder{
      color: white;
      opacity: 0.5;
      ${SearchInputStyle}.font-size;
      ${SearchInputStyle}.font-family;
      ${SearchInputStyle}.font-weight;
    }
    &:focus{
      box-shadow: none;
      outline: none;
    }
`,
);

export const UpdateSearchBtn = styled(ButtonBase)(
  props => `
  background-color: ${props.theme.colors.goWhite.base};
  margin-top: ${props.theme.spacing.large};
  height: 4.2rem;
  width: 19.6rem;
  color: ${props.theme.colors.downriver.base};
`,
);
